export default __webpack_public_path__ + "static/media/sellers-selected.797cf638.svg";